export default __webpack_public_path__ + "811a15fa80e3f94c5935298c1ecfb8fa.png";